import React,{useState} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
// import Navbar2 from '../components/Navbar2';



import Footer from '../components/Footer';
import DiscoverPage from '../components/Discover';
import Sroll from '../components/Scroll';

function Discover() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <>
         <Sidebar isOpen={isOpen} toggle={toggle} />
         <Navbar toggle={toggle} /> 
         <DiscoverPage />
         
         <Sroll />
         <Footer />
        </>
    )
}

export default Discover